class ScrollingVideo extends window.BAO.CustomElement() {
  static get styles () {
    return ':host { display: block; }'
  }

  connectedCallback () {
    super.connectedCallback()

    this.videoPlaying = false

    this.video =
      window.innerWidth > 900
        ? this.els.desktopVideo?.element
        : this.els.mobileVideo?.element

    if (this.video.readyState === 0) {
      this.video.addEventListener(
        'progress',
        () => {
          this.configureCanvas()
        },
        { once: true },
      )
    } else {
      this.configureCanvas()
    }

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      this.intersectionObserverCallback.bind(this),
      {
        threshold: this.threshold,
      },
    )

    window.setTimeout(() => {
      this.els?.observable?.elements?.forEach(observableEl =>
        this.observer.observe(observableEl),
      )
    }, 200)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer.unobserve(this)
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.desktopVideo?.element) {
      this.listeners.add(this.els.desktopVideo.element, 'seeked', () => {
        this.seeked = true
      })
    }

    if (this.els.mobileVideo?.element) {
      this.listeners.add(this.els.mobileVideo.element, 'seeked', () => {
        this.seeked = true
      })
    }

    this.configureCanvas = this.configureCanvas.bind(this)
    this.animateVideo = this.animateVideo.bind(this)

    this.listeners.add(window, 'resize', this.configureCanvas.bind(this))
  }

  intersectionObserverCallback (entries) {
    if (!entries?.length) return

    entries.forEach(entry => {
      if (this.videoPlaying) return

      if (entry.isIntersecting) {
        this.videoPlaying = true

        this.els?.intersectionVideo?.element?.addEventListener(
          'loadeddata',
          this.setVideo(),
        )
      }
    })
  }

  setVideo () {
    this.els?.intersectionVideo?.element?.play()
  }

  configureCanvas () {
    this.ctx = this.els.canvas.element.getContext('2d')
    this.els.canvas.element.height = this.video.videoHeight
    this.els.canvas.element.width = this.video.videoWidth

    this.end = parseInt(this.video.dataset.videoEnd) / 100
    this.seeked = false
    this.currentTime = 0.01

    requestAnimationFrame(this.animateVideo)
  }

  animateVideo () {
    requestAnimationFrame(this.animateVideo)

    if (!this.seeked) return

    const canvas = this.els.canvas.element
    const container = this.els.container.element
    const containerPos = container.getBoundingClientRect()

    if (isNaN(this.video.duration)) {
      return
    }

    const announcementBar = document.querySelector('header-announcement-bar')
    const announcementBarHeight =
      announcementBar !== null ? announcementBar.offsetHeight : 0
    const headerEl = document.querySelector('.hd-Header')
    const headerHeight = headerEl?.offsetHeight || 0
    const combinedHeight = announcementBarHeight + headerHeight

    const scrollPercent =
      -(containerPos.top - combinedHeight) /
      (container.offsetHeight - this.video.offsetHeight)

    const duration = Math.floor(this.video.duration)
    let currentTime = duration * scrollPercent

    if (currentTime < 0) {
      currentTime = 0
    }

    if (currentTime > duration) {
      currentTime = duration
    }

    if (currentTime === this.currentTime) {
      return
    }

    this.seeked = false

    this.currentTime = currentTime

    this.ctx.clearRect(0, 0, canvas.width, canvas.height)
    this.ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height)
  }

  get intersectionVideoEl () {
    return this.els?.intersectionVideo?.element
  }

  get currentTime () {
    return this._currentTime
  }

  set currentTime (time) {
    this._currentTime = time
    this.video.currentTime = parseFloat(time.toFixed(2))
  }

  get seeked () {
    return this._seeked
  }

  set seeked (seeked) {
    this._seeked = seeked
  }

  get threshold () {
    return this.hasAttribute('threshold')
      ? Number(this.getAttribute('threshold'))
      : 0
  }
}

if (!customElements.get('scrolling-video')) {
  customElements.define('scrolling-video', ScrollingVideo)
}
